import client from './client';

export const measurementsApi = {
  getAll: (params) => client.get('/measurements', { params }),
  create: (data, params, config) => client.post('/measurements', data, { params, ...config }),
  update: (id, data) => client.put(`/measurements/${id}`, data),
  getPhotos: (id) => client.get(`/measurements/${id}/photos`),
  delete: (id) => client.delete(`/measurements/${id}`),
  getSchedule: () => client.get('/measurements/schedule/me'),
  updateCoachNotes: (id, data) => client.put(`/measurements/${id}/coach-notes`, data),

  skipCheckin: (reason) => client.post('/measurements/skip-checkin', { reason }),
  coachSkipCheckin: (clientId, reason) => client.post(`/measurements/skip-checkin/${clientId}`, { reason }),

  patchKeypoints: (id, photoKeypoints) =>
    client.patch(`/measurements/${id}/keypoints`, { photo_keypoints: photoKeypoints }),

  // Check-ins
  getCheckins: (params) => client.get('/check-ins', { params }),
  createCheckin: (data) => client.post('/check-ins', data),
};
